import React, { useState } from "react";
import {
  Card,
  Image,
  Typography,
  Avatar,
  Button,
  Divider,
  message,
  Space,
  Modal,
  Alert,
} from "antd";
import BetterComunicate from "../../assets/images/better-comnuicate.svg";
import ProductiveThumb from "../../assets/images/resolveit-start-chat.png";
import DeclinedJournal from "../../assets/images/declined-journal.svg";
import WaitingResponse from "../../assets/images/waiting-response.png";
import Accepting from "../../assets/images/accepting.png";
import ArchivedImage from "../../assets/images/archived-image.svg";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import {
  allDiaries,
  currentDiaryTopic,
  diaryEntries,
  diaryStatus,
  entriesLoader,
  saveAllDiaries,
  saveDiaryStatus,
  saveHideClassName,
} from "redux/diaries/diariesSlice";
import StartDiaryModal from "features/myDiaries/modals/startDiaryModal";
import NetworkCall from "network/networkCall";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  convertToPlanDate,
  downloadEvent,
  getInitials,
} from "utilities/generalUtility";
import InitialAvatar from "common/components/Initials/InitialAvatar";
import Request from "network/request";
import { InfoCircleTwoTone } from "@ant-design/icons";
import { userDetails } from "redux/roles/userRoleSlice";

const { Title, Paragraph } = Typography;

export default function JournalRequest() {
  const DiaryEntries = useSelector(diaryEntries);
  const selected = useSelector(currentDiaryTopic);
  const currStatus = useSelector(diaryStatus);
  const diaries = useSelector(allDiaries);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [acceptBtnLoading, setAcceptBtnLoading] = useState(false);
  const [declineBtnLoading, setDeclineBtnLoading] = useState(false);
  const loading = useSelector(entriesLoader);
  const [resendLoading, setResend] = useState(false);
  const [open, setopen] = useState(false);
  const userData = useSelector(userDetails);
  const [searchParam, setSearchParam] = useSearchParams();

  const handleDiaryStatus = async (status) => {
    try {
      status === "Accepted"
        ? setAcceptBtnLoading(true)
        : setDeclineBtnLoading(true);
      const body = {
        diaryId: currStatus?.diary.diaryId,
        status,
      };
      const response = await NetworkCall.fetch(
        Request.UpdateInvite(body),
        false
      );
      let temp = [...diaries];
      const index = temp?.findIndex(
        (e) => e?.diaryId === currStatus?.diary.diaryId
      );
      temp[index] = {
        ...temp[index],
        status: {
          ...temp[index]?.status,
          id: status === "Accepted" ? 1 : 2,
          name: status,
        },
      };
      dispatch(saveAllDiaries(temp));
      dispatch(saveDiaryStatus({ diary: temp[index] }));
      setAcceptBtnLoading(false);
      setDeclineBtnLoading(false);
      const params = `?diaryId=${currStatus?.diary?.diaryId}&diaryTopicId=${currStatus?.diary?.topics[0]?.id}`;

      status === "Accepted" && navigate(`/${params}`);
    } catch (error) {
      message.error(error?.message);
      setAcceptBtnLoading(false);
      setDeclineBtnLoading(false);
    }
  };

  const handleResendInvite = async () => {
    try {
      setResend(true);
      downloadEvent("ResendInvite");

      const response = await NetworkCall.fetch(
        Request.resendJournalInvite(
          `diaryTopicId=${currStatus?.diary?.topics[0]?.id}`
        ),
        false
      );
      message.success(response?.message);
      let temp = [...diaries];
      const index = temp?.findIndex(
        (e) => e?.diaryId === currStatus?.diary.diaryId
      );
      temp[index] = {
        ...temp[index],
        status: {
          ...temp[index]?.status,
          id: 3,
          name: "Pending",
        },
        isCreator: true,
      };
      dispatch(saveAllDiaries(temp));
      dispatch(saveDiaryStatus({ diary: temp[index] }));
      setResend(false);
    } catch (error) {
      error?.statusCode === 403 && message.warning(error?.message, 5);
      setResend(false);
    }
  };
  const title = (name, relation, topic) => (
    <>
      <Button
        className="arrow-left-btn"
        type="text"
        icon={<i className="icon-left-arrow" />}
        onClick={() => {
          dispatch(saveHideClassName(""));
        }}
      ></Button>
      <div className="lock-area">
        <Title className="name mb-0" level={5}>
          <span>{name}</span>{" "}
          {relation && relation !== "" && (
            <Space className="relation mr-1" size={0}>
              <Divider type="vertical" />
              {relation}
            </Space>
          )}
        </Title>
      </div>
      <Link className="mt-0 comunicate-issue" level={5}>
        <i className="icon-chat"></i>
        <span>{topic}</span>
      </Link>
    </>
  );

  return (
    <>
      {" "}
      {userData?.subscriptionStatus === "trialing" && (
        <Alert
          className="chat-alert warning journal-req-alert"
          icon={<InfoCircleTwoTone twoToneColor="#CC8406" />}
          description={
            <>
              {`Your trial period will expire on ${convertToPlanDate(
                moment,
                userData?.subscriptionExpiryDate
              )}`}
            </>
          }
          type="warning"
          showIcon
        />
      )}
      <Card
        title={title(
          currStatus?.diary?.userName,
          currStatus?.diary?.relationship,
          selected?.topicName
        )}
        className={`journal-request-wrapper ${
          diaries.length > 0 && currStatus?.diary && "resolvit-chat-box"
        }`}
      >
        {diaries.length > 0 && !loading ? (
          currStatus?.diary ? (
            currStatus?.diary?.status?.id === 1 ? (
              selected?.topicId ? (
                DiaryEntries.length <= 0 && (
                  // when no entry in the selected topic
                  <div className="productive-journal-card">
                    <Image src={Accepting} preview={false} />
                    <Title level={5} className="mb-0">
                      Thank you for accepting a request.{" "}
                      {currStatus?.diary?.userName.split(" ")[0]} is creating a
                      journal for you
                    </Title>
                  </div>
                )
              ) : (
                // when no selected topic
                <div className="productive-journal-card">
                  <Image src={WaitingResponse} preview={false} />
                  <Title level={5} className="mb-0">
                    Start a healthy and productive journal from selected 2
                  </Title>
                </div>
              )
            ) : // declined

            currStatus?.diary?.status?.id === 2 ? (
              // when other person declined the diary
              currStatus?.diary?.isCreator ? (
                <div className="productive-journal-card decline-card">
                  <Image
                    className="mb-4"
                    src={DeclinedJournal}
                    preview={false}
                  />
                  <Title level={5} className="mb-0 mt-2">
                    Your journal has been declined by{" "}
                    {currStatus?.diary?.userName}
                  </Title>
                  <Title level={5} className="mb-0 mt-2">
                    Click 'Resend' to resend the invite
                  </Title>
                  <Button
                    className="mt-2"
                    type="primary"
                    onClick={handleResendInvite}
                    loading={resendLoading}
                  >
                    Resend
                  </Button>
                </div>
              ) : (
                // when you declined the diary
                <div className="productive-journal-card decline-card">
                  <Image
                    className="mb-4"
                    src={DeclinedJournal}
                    preview={false}
                  />
                  <Title level={5} className="mb-0 mt-2">
                    You have declined this journal request.
                  </Title>
                  <Title level={5} className="mb-0 mt-2">
                    Click 'Send' to send back the invite
                  </Title>
                  <Button
                    className="mt-2"
                    type="primary"
                    onClick={handleResendInvite}
                    loading={resendLoading}
                  >
                    Send
                  </Button>
                </div>
              )
            ) : currStatus?.diary?.status?.id === 4 ? (
              // when other person blocked you
              currStatus?.diary?.isCreator ? (
                <div className="productive-journal-card decline-card">
                  <Image
                    className="mb-4"
                    src={DeclinedJournal}
                    preview={false}
                  />
                  <Title level={5} className="mb-0 mt-2">
                    Your journal has been declined by{" "}
                    {currStatus?.diary?.userName}
                  </Title>
                  <Title level={5} className="mb-0 mt-2">
                    Click 'Resend' to resend the invite
                  </Title>
                  <Button
                    className="mt-2"
                    type="primary"
                    onClick={handleResendInvite}
                    loading={resendLoading}
                  >
                    Resend
                  </Button>
                </div>
              ) : (
                // when you block the other person
                <div className="productive-journal-card decline-card">
                  <Image
                    className="mb-4"
                    src={DeclinedJournal}
                    preview={false}
                  />
                  <Title level={5} className="mb-0 mt-2">
                    You have blocked this user.
                  </Title>

                  <Button
                    className="mt-2"
                    type="primary"
                    onClick={() => setopen(true)}
                  >
                    Unblock
                  </Button>
                </div>
              )
            ) : currStatus?.diary?.isCreator ? (
              // sending a request and waiting for response
              <div className="productive-journal-card">
                <Image src={WaitingResponse} preview={false} />
                <Title level={5} className="mb-0">
                  Your Journal request has been sent to{" "}
                  {currStatus?.diary?.userName}
                  <p>Please wait for response</p>
                </Title>
              </div>
            ) : (
              // Accpet or Decline
              <Card className="accept-decline-card ">
                <div className="card-head">
                  <Avatar
                    size={55}
                    src={
                      <InitialAvatar
                        initials={getInitials(
                          currStatus?.diary?.userName.split(" ")[0],
                          currStatus?.diary?.userName.split(" ")[1]
                        )}
                        check={"55"}
                      />
                    }
                  />
                  <div>
                    <Title level={2}>{currStatus?.diary?.userName}</Title>
                    <p>{currStatus?.diary?.relationship}</p>
                  </div>
                </div>
                <Divider dashed />

                <Paragraph className="decline-card">
                  {
                    currStatus?.diary?.relationshipType?.id === 1
                      ? " We’re on our way to RESOLVEit! Thanks for doing this with me!" //Professional
                      : " We’re on our way to RESOLVEit! Thanks for doing this with me!" //Personal
                  }
                </Paragraph>
                <div className="card-btn">
                  <Button
                    ghost
                    type="primary"
                    onClick={() => {
                      downloadEvent("DeclineInvite");

                      handleDiaryStatus("Declined");
                    }}
                    loading={declineBtnLoading}
                  >
                    Decline
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      downloadEvent("AcceptInvite");
                      handleDiaryStatus("Accepted");
                    }}
                    loading={acceptBtnLoading}
                  >
                    Accept
                  </Button>
                </div>
              </Card>
            )
          ) : // First Time Landing
          searchParam.get("archived") ? (
            <div className="better-comunicate-wrap">
              <Image src={ArchivedImage} preview={false} />
              <Title level={2} className="mb-0">
                Unveiling the Archives
              </Title>
              <Title level={5} className="mb-0">
                Explore your archive journals here. You can unarchive them to
                restore your communication.
              </Title>
            </div>
          ) : (
            <div className="better-comunicate-wrap">
              <Image src={BetterComunicate} preview={false} />
              <Title level={2} className="mb-0">
                A Better Way to Communicate
              </Title>
              <Title level={5} className="mb-0">
                Stop fighting and struggling through difficult issues. RESOLVEit
                is the best way to clearly communicate with anyone on important
                but difficult issues.
              </Title>
            </div>
          )
        ) : (
          // When there is no diary. just the new account
          !loading && (
            <div className="productive-journal-card">
              <Image src={ProductiveThumb} preview={false} />
              <Title level={5} className="mb-4">
                Start a healthy and productive journal.
              </Title>
              <div className="mb-5">
                <StartDiaryModal flag={true} />
              </div>
            </div>
          )
        )}
        <Modal
          centered
          mask={false}
          open={open}
          onOk={() => {
            handleDiaryStatus("Accepted");
          }}
          onCancel={() => setopen(false)}
          closable={false}
          className="post-confirmation-modal"
          okText="Yes"
          cancelText="No"
          okButtonProps={{
            loading: acceptBtnLoading,
          }}
          cancelButtonProps={{
            ghost: true,
          }}
        >
          <Title level={4}>Confirmation</Title>
          <Paragraph className="text">
            This will unblock the user and you can proceed with the journal.
            Would you like to continue?
          </Paragraph>
        </Modal>
      </Card>
    </>
  );
}
